import { createStore, compose, applyMiddleware } from 'redux';
import reducers from './reducers';
import middlewares from './middlewares';

const { routerMiddleware, logger } = middlewares;

export default (history) => (preloadState = {}) => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducers(history),
    preloadState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        logger({
          collapsed: (getState, action) => action.type.includes('@@router/'),
        })
      )
    )
  );
  return store;
};
